module.exports = __webpack_public_path__ + "img/CrowdStrike-Falcon.2e7d81b.svg";